import { IconButton } from '@material-ui/core';
import type { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import clsx from 'clsx';
import React from 'react';

import styles from './Panel.module.css';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    exitButton: {
      '&:hover': {
        backgroundColor: '#7e92c7',
      },
      width: theme.spacing(5),
      height: theme.spacing(5),
      backgroundColor: '#8595c0',
    },
    exitIcon: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      color: 'white',
    },
  }),
);

interface Props {
  className?: string;
  bodyClassName?: string;
  title?: string;
  hasExitModalButton?: boolean;
  hideModal?: () => void;
}

export const Panel: React.FC<Props> = props => {
  const classes = useStyles();
  return (
    <div className={clsx(props.className, styles.customPanel)}>
      {props.hasExitModalButton ?? false ? (
        <div className={styles.customPanelTitleContainer}>
          <div className={styles.customPanelTitleWithExitIcon}>
            {props.title}
          </div>
          <div className={''}>
            <IconButton
              className={classes.exitButton}
              onClick={props.hideModal}
            >
              <ClearIcon className={classes.exitIcon} />
            </IconButton>
          </div>
        </div>
      ) : (
        props.title != null &&
        props.title && (
          <div className={styles.customPanelTitle}>{props.title}</div>
        )
      )}
      <div className={clsx(props.bodyClassName, styles.customPanelBody)}>
        {props.children}
      </div>
    </div>
  );
};
